import { error } from "jquery";
import { apiRequest } from "../../services/apiService";
import { ADD_CUSTOM_FORMULA_FAIL, ADD_CUSTOM_FORMULA_REQUEST, ADD_CUSTOM_FORMULA_SUCCESS, ADD_CUSTOM_VARIABLE_FAIL, ADD_CUSTOM_VARIABLE_REQUEST, ADD_CUSTOM_VARIABLE_SUCCESS, ADD_STAGE_FAIL, ADD_STAGE_REQUEST, ADD_STAGE_SUCCESS, ADD_UTM_VARIABLE_FAIL, ADD_UTM_VARIABLE_REQUEST, ADD_UTM_VARIABLE_SUCCESS, DELETE_CUSTOM_FORMULA_FAIL, DELETE_CUSTOM_FORMULA_REQUEST, DELETE_CUSTOM_FORMULA_SUCCESS, DELETE_CUSTOM_VARIABLE_FAIL, DELETE_CUSTOM_VARIABLE_REQUEST, DELETE_CUSTOM_VARIABLE_SUCCESS, DELETE_STAGE_FAIL, DELETE_STAGE_REQUEST, DELETE_STAGE_SUCCESS, DELETE_UTM_VARIABLE_FAIL, DELETE_UTM_VARIABLE_REQUEST, DELETE_UTM_VARIABLE_SUCCESS, GET_CUSTOM_FORMULA_FAIL, GET_CUSTOM_FORMULA_REQUEST, GET_CUSTOM_FORMULA_SUCCESS, GET_CUSTOM_VARIABLE_FAIL, GET_CUSTOM_VARIABLE_REQUEST, GET_CUSTOM_VARIABLE_SUCCESS, GET_FIELD_FAIL, GET_FIELD_REQUEST, GET_FIELD_SUCCESS, GET_LEAD_GEN_VARIABLE_FAIL, GET_LEAD_GEN_VARIABLE_REQUEST, GET_LEAD_GEN_VARIABLE_SUCCESS, GET_STAGE_FAIL, GET_STAGE_REQUEST, GET_STAGE_SUCCESS, GET_UTM_VARIABLE_FAIL, GET_UTM_VARIABLE_REQUEST, GET_UTM_VARIABLE_SUCCESS, UPDATE_CUSTOM_FORMULA_FAIL, UPDATE_CUSTOM_FORMULA_REQUEST, UPDATE_CUSTOM_FORMULA_SUCCESS, UPDATE_CUSTOM_VARIABLE_FAIL, UPDATE_CUSTOM_VARIABLE_REQUEST, UPDATE_CUSTOM_VARIABLE_STATUS_FAIL, UPDATE_CUSTOM_VARIABLE_STATUS_REQUEST, UPDATE_CUSTOM_VARIABLE_STATUS_SUCCESS, UPDATE_CUSTOM_VARIABLE_SUCCESS, UPDATE_STAGE_FAIL, UPDATE_STAGE_REQUEST, UPDATE_STAGE_SUCCESS, UPDATE_UTM_VARIABLE_FAIL, UPDATE_UTM_VARIABLE_REQUEST, UPDATE_UTM_VARIABLE_SUCCESS } from "../constant";


//Custom Variable
export const getCustomVariable = (id) => {
    return async (dispatch) => {
        dispatch({ type: GET_CUSTOM_VARIABLE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getCustomVarList?survey_id=${id}`,
        })
        if (response) {
            dispatch({ type: GET_CUSTOM_VARIABLE_SUCCESS, payload: response?.data?.data });
        }
        else if (error) {
            dispatch({ type: GET_CUSTOM_VARIABLE_FAIL });
        }
    }
}

export const addCustomVariable = (data, successCallback, setNameErrorMsg) => {
    return async (dispatch) => {

        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/getCustomVarUniqueness`,
            data: {
                survey_id: data.survey_id,
                name: data.su_name
            }
        })
        if (response) {
            if (response.data?.data?.length === 0) {
                dispatch({ type: ADD_CUSTOM_VARIABLE_REQUEST })
                const { response, error } = await apiRequest({
                    method: 'POST',
                    url: `/survey/crtCustomVar`,
                    data: data
                })
                if (response) {
                    dispatch({ type: ADD_CUSTOM_VARIABLE_SUCCESS, payload: response?.data?.data });
                    successCallback()
                }
                else if (error) {
                    dispatch({ type: ADD_CUSTOM_VARIABLE_FAIL });
                }
            } else {
                setNameErrorMsg()
            }
        }
        else if (error) {
            console.log('Error in checking variable name.', error)
        }

    }
}

export const updateCustomVariable = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_CUSTOM_VARIABLE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/updCustomVars`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_CUSTOM_VARIABLE_SUCCESS });
            successCallback()
        }
        else if (error) {
            dispatch({ type: UPDATE_CUSTOM_VARIABLE_FAIL });
        }
    }
}

export const deleteCustomVariable = (id) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_CUSTOM_VARIABLE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/delCustomVariable?su_custom_variable_id=${id}`,
        })
        if (response) {
            dispatch({ type: DELETE_CUSTOM_VARIABLE_SUCCESS, payload: id });
        }
        else if (error) {
            dispatch({ type: DELETE_CUSTOM_VARIABLE_FAIL });
        }
    }
}

export const updateCustomVariableRequirement = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_CUSTOM_VARIABLE_STATUS_REQUEST })
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/reqCustomVarList`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_CUSTOM_VARIABLE_STATUS_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: UPDATE_CUSTOM_VARIABLE_STATUS_FAIL })
        }
    }
}

//Custom Formula 
export const getCustomFormula = (id) => {
    return async (dispatch) => {
        dispatch({ type: GET_CUSTOM_FORMULA_REQUEST });
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getCustomFormulaList?survey_id=${id}`,
        })
        if (response) {
            dispatch({ type: GET_CUSTOM_FORMULA_SUCCESS, payload: response?.data?.result });
        }
        else if (error) {
            dispatch({ type: GET_CUSTOM_FORMULA_FAIL });
        }
    }
}

export const addCustomFormula = (data, successCallback, failCallback) => {
    return async (dispatch) => {
        dispatch({ type: ADD_CUSTOM_FORMULA_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/crtCustomFormula`,
            data: data
        })
        if (response) {
            dispatch({ type: ADD_CUSTOM_FORMULA_SUCCESS });
            successCallback()
        }
        else if (error) {
            const err = error.response?.data?.result
            if (!err.isUnique) {
                failCallback({ name: 'Formula with this name already exist' })
            }
            dispatch({ type: ADD_CUSTOM_FORMULA_FAIL });
        }
    }
}

export const updateCustomFormula = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_CUSTOM_FORMULA_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/updCustomFormula`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_CUSTOM_FORMULA_SUCCESS });
            successCallback()
        }
        else if (error) {
            dispatch({ type: UPDATE_CUSTOM_FORMULA_FAIL });
        }
    }
}

export const deleteCustomFormula = (id) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_CUSTOM_FORMULA_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/delCustomFormula?su_custom_formula_id=${id}`,
        })
        if (response) {
            dispatch({ type: DELETE_CUSTOM_FORMULA_SUCCESS, payload: id });
        }
        else if (error) {
            dispatch({ type: DELETE_CUSTOM_FORMULA_FAIL });
        }
    }
}

//UTM Variable 
export const getUtmVariable = (survey_id = null, group_id = null, link_scope = 'survey') => {
    return async (dispatch) => {
        dispatch({ type: GET_UTM_VARIABLE_REQUEST });
        
        // Build query parameters based on context
        let queryParams = '';
        if (group_id) {
            queryParams = `group_id=${group_id}&link_scope=group`;
        } else if (survey_id) {
            queryParams = `survey_id=${survey_id}&link_scope=survey`;
        } else {
            // Fallback for backward compatibility
            queryParams = `survey_id=${survey_id || ''}`;
        }
        
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getUtmVariableList?${queryParams}`,
            showErrorToast: false,
        })
        if (response) {
            dispatch({ type: GET_UTM_VARIABLE_SUCCESS, payload: response.data?.data || response.data?.result });
        }
        else if (error) {
            dispatch({ type: GET_UTM_VARIABLE_FAIL });
        }
    }
}

export const addUtmVariable = (data, successCallback, errorCallback = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: ADD_UTM_VARIABLE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/crtUtmVar`,
            data: data
        })
        if (response) {
            dispatch({ type: ADD_UTM_VARIABLE_SUCCESS });
            successCallback()
        }
        else if (error) {
            errorCallback(error.response?.data?.result?.msg)
            dispatch({ type: ADD_UTM_VARIABLE_FAIL });
        }
    }
}

export const updateUtmVariable = (data, successCallback, errorCallback = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_UTM_VARIABLE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/updateUtmVariableList`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_UTM_VARIABLE_SUCCESS, payload: data });
            successCallback()
        }
        else if (error) {
            errorCallback(error.response?.data?.result?.msg)
            dispatch({ type: UPDATE_UTM_VARIABLE_FAIL });
        }
    }
}

export const deleteUtmVariable = (id, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_UTM_VARIABLE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/deleteUtmVariable?su_suv_id=${id}`,
        })
        if (response) {
            dispatch({ type: DELETE_UTM_VARIABLE_SUCCESS, payload: id });
            successCallback()
        }
        else if (error) {
            dispatch({ type: DELETE_UTM_VARIABLE_FAIL });
        }
    }
}

//Stages
export const getStages = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_STAGE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/getStageList`,
            data: data
        })
        if (response) {
            dispatch({ type: GET_STAGE_SUCCESS, payload: response?.data?.data });
        }
        else if (error) {
            dispatch({ type: GET_STAGE_FAIL });
        }
    }
}

export const addStage = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: ADD_STAGE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/crtStage`,
            data: data
        })
        if (response) {
            dispatch({ type: ADD_STAGE_SUCCESS });
            successCallback()
        }
        else if (error) {
            dispatch({ type: ADD_STAGE_FAIL });
        }
    }
}

export const updateStage = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_STAGE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updStage`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_STAGE_SUCCESS });
            successCallback()
        }
        else if (error) {
            dispatch({ type: UPDATE_STAGE_FAIL });
        }
    }
}

export const deleteStage = (id) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_STAGE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/deleteStage?stageId=${id}`,
        })
        if (response) {
            dispatch({ type: DELETE_STAGE_SUCCESS, payload: id })
        }
        else if (error) {
            dispatch({ type: DELETE_STAGE_FAIL })
        }
    }
}

//Lead-gen
export const getLeadGenVariable = (survey_id) => {
    return async (dispatch) => {
        dispatch({ type: GET_LEAD_GEN_VARIABLE_REQUEST })
        dispatch({ type: GET_FIELD_REQUEST })
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getLeadGenVar?survey_id=${survey_id}`,
        })
        if (response) {
            dispatch({ type: GET_LEAD_GEN_VARIABLE_SUCCESS, payload: response.data?.result })
            dispatch({ type: GET_FIELD_SUCCESS, payload: response.data?.result })
        }
        else if (error) {
            dispatch({ type: GET_LEAD_GEN_VARIABLE_FAIL })
            dispatch({ type: GET_FIELD_FAIL })
        }
    }
}